import inegiCuliacanBlocks from "@/data/inegi-culiacan-manzanas.json";

const DEFAULT_RADIUS_METERS = 1000;
const EARTH_RADIUS_METERS = 6371000;

const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : 0;
};

const parseCoordinatesFromProperty = (property) => {
  if (property?.lat && property?.lng) {
    return {
      lat: Number(property.lat),
      lng: Number(property.lng),
    };
  }

  const mapUrl = decodeURIComponent(property?.mapUrl || "");
  const match = mapUrl.match(/q=([-0-9.]+)\s*,\s*([-0-9.]+)/);

  if (!match) return null;

  return {
    lat: Number(match[1]),
    lng: Number(match[2]),
  };
};

const getDistanceMeters = (a, b) => {
  const lat1 = (a.lat * Math.PI) / 180;
  const lat2 = (b.lat * Math.PI) / 180;
  const deltaLat = ((b.lat - a.lat) * Math.PI) / 180;
  const deltaLng = ((b.lng - a.lng) * Math.PI) / 180;

  const haversine =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1) *
      Math.cos(lat2) *
      Math.sin(deltaLng / 2) *
      Math.sin(deltaLng / 2);

  return (
    EARTH_RADIUS_METERS *
    2 *
    Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine))
  );
};

export const getPropertyInegiZoneStats = (
  property,
  radiusMeters = DEFAULT_RADIUS_METERS
) => {
  const coordinates = parseCoordinatesFromProperty(property);
  if (!coordinates) return null;

  const blocksInRadius = inegiCuliacanBlocks.blocks.filter((block) => {
    if (!block.lat || !block.lng) return false;
    return getDistanceMeters(coordinates, block) <= radiusMeters;
  });

  if (!blocksInRadius.length) return null;

  const stats = blocksInRadius.reduce(
    (totals, block) => ({
      population: totals.population + toNumber(block.population),
      women: totals.women + toNumber(block.women),
      men: totals.men + toNumber(block.men),
      occupiedHomes:
        totals.occupiedHomes + toNumber(block.occupiedHomes ?? block.homes),
    }),
    {
      population: 0,
      women: 0,
      men: 0,
      occupiedHomes: 0,
    }
  );

  return {
    ...stats,
    radiusMeters,
    blocks: blocksInRadius.length,
    source: inegiCuliacanBlocks.source,
  };
};
